(function () {
  var STORAGE_KEY = 'glitz_wishlist';

  function getList() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function setList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      updateHeaderCount();
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: list } }));
    } catch (e) {}
  }

  function updateHeaderCount() {
    var list = getList();
    var bubbles = document.querySelectorAll('.wishlist-count-bubble');
    bubbles.forEach(function (el) {
      var num = el.querySelector('span[aria-hidden="true"]');
      if (num) num.textContent = list.length;
      el.classList.toggle('hidden', list.length === 0);
    });
  }

  function openDrawer() {
    var drawer = document.getElementById('WishlistDrawer');
    if (!drawer) return;
    renderDrawer();
    drawer.classList.add('active');
    document.body.style.overflow = 'hidden';
    drawer.querySelector('.wishlist-drawer__close').focus();
  }

  function closeDrawer() {
    var drawer = document.getElementById('WishlistDrawer');
    if (!drawer) return;
    drawer.classList.remove('active');
    document.body.style.overflow = '';
  }

  function renderDrawer() {
    var container = document.getElementById('wishlist-drawer-items');
    var emptyEl = document.getElementById('wishlist-drawer-empty');
    var contentEl = document.getElementById('wishlist-drawer-content');
    if (!container) return;
    var list = getList();
    if (emptyEl) emptyEl.style.display = list.length === 0 ? 'flex' : 'none';
    if (contentEl) contentEl.classList.toggle('hidden', list.length === 0);
    if (list.length === 0) return;
    container.innerHTML = list.map(function (item) {
      var img = item.image ? '<img src="' + item.image + '" alt="" width="80" height="80" loading="lazy">' : '';
      var price = item.price ? '<span class="wishlist-item__price">' + item.price + '</span>' : '';
      return '<div class="wishlist-item" data-product-id="' + (item.id || '') + '">' +
        '<a href="' + (item.url || '#') + '" class="wishlist-item__link">' +
          '<span class="wishlist-item__image">' + img + '</span>' +
          '<span class="wishlist-item__title">' + (item.title || '') + '</span>' + price +
          '<button type="button" class="wishlist-item__remove button button--tertiary" data-wishlist-remove="' + (item.id || '') + '" aria-label="Remove from wishlist">&times;</button>' +
        '</a>' +
      '</div>';
    }).join('');
  }

  function handleWishlistItemClick(e, removeBtn) {
    if (!removeBtn) removeBtn = (e.target.closest && e.target.closest('[data-wishlist-remove]')) || (e.target.parentElement && e.target.parentElement.closest('[data-wishlist-remove]'));
    if (!removeBtn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = removeBtn.getAttribute('data-wishlist-remove');
    remove(id);
    var row = removeBtn.closest('.wishlist-item');
    if (row) row.remove();
    updateHeaderCount();
    var list = getList();
    if (document.getElementById('wishlist-drawer-empty')) document.getElementById('wishlist-drawer-empty').style.display = list.length === 0 ? 'flex' : 'none';
    if (document.getElementById('wishlist-drawer-content')) document.getElementById('wishlist-drawer-content').classList.toggle('hidden', list.length === 0);
    if (document.getElementById('wishlist-empty')) document.getElementById('wishlist-empty').hidden = list.length > 0;
    if (document.getElementById('wishlist-grid')) document.getElementById('wishlist-grid').hidden = list.length === 0;
  }

  function getProductData(btn) {
    return {
      id: btn.getAttribute('data-product-id'),
      handle: btn.getAttribute('data-product-handle'),
      title: btn.getAttribute('data-product-title'),
      url: btn.getAttribute('data-product-url'),
      image: btn.getAttribute('data-product-image'),
      price: btn.getAttribute('data-product-price') || ''
    };
  }

  function isInWishlist(id) {
    return getList().some(function (item) { return item.id === id; });
  }

  function add(data) {
    var list = getList();
    if (list.some(function (item) { return item.id === data.id; })) return;
    list.push(data);
    setList(list);
  }

  function remove(id) {
    setList(getList().filter(function (item) { return item.id !== id; }));
  }

  function toggle(btn) {
    var data = getProductData(btn);
    if (!data.id) return;
    var inList = isInWishlist(data.id);
    if (inList) remove(data.id);
    else add(data);
    setButtonState(btn, !inList);
  }

  function setButtonState(btn, inWishlist) {
    btn.setAttribute('aria-pressed', inWishlist ? 'true' : 'false');
    var outline = btn.querySelector('.wishlist-button__icon--outline');
    var filled = btn.querySelector('.wishlist-button__icon--filled');
    if (outline) outline.classList.toggle('visually-hidden', inWishlist);
    if (filled) filled.classList.toggle('visually-hidden', !inWishlist);
  }

  function renderWishlistPage() {
    var container = document.getElementById('wishlist-page-items');
    if (!container) return;
    var list = getList();
    var emptyEl = document.getElementById('wishlist-empty');
    var gridEl = document.getElementById('wishlist-grid');
    if (emptyEl) emptyEl.hidden = list.length > 0;
    if (gridEl) gridEl.hidden = list.length === 0;
    if (list.length === 0) return;
    container.innerHTML = list.map(function (item) {
      var img = item.image ? '<img src="' + item.image + '" alt="" width="200" height="200" loading="lazy">' : '';
      var price = item.price ? '<span class="wishlist-item__price">' + item.price + '</span>' : '';
      return '<div class="wishlist-item" data-product-id="' + (item.id || '') + '">' +
        '<a href="' + (item.url || '#') + '" class="wishlist-item__link">' +
          '<span class="wishlist-item__image">' + img + '</span>' +
          '<span class="wishlist-item__title">' + (item.title || '') + '</span>' + price +
          '<button type="button" class="wishlist-item__remove button button--tertiary" data-wishlist-remove="' + (item.id || '') + '" aria-label="Remove from wishlist">&times;</button>' +
        '</a>' +
      '</div>';
    }).join('');
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateHeaderCount();
    document.querySelectorAll('[data-wishlist-button]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      setButtonState(btn, id ? isInWishlist(id) : false);
      btn.addEventListener('click', function () { toggle(btn); });
    });
    renderWishlistPage();

    var wishlistIcon = document.getElementById('wishlist-icon');
    if (wishlistIcon) {
      wishlistIcon.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    }
    var overlay = document.getElementById('WishlistDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', closeDrawer);
    var closeBtn = document.querySelector('.wishlist-drawer__close');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    document.addEventListener('click', function (e) {
      var removeBtn = (e.target.closest && e.target.closest('[data-wishlist-remove]')) ||
        (e.target.parentElement && e.target.parentElement.closest && e.target.parentElement.closest('[data-wishlist-remove]'));
      if (!removeBtn) return;
      var inDrawer = removeBtn.closest('#wishlist-drawer-items');
      var inPage = removeBtn.closest('#wishlist-page-items');
      if (!inDrawer && !inPage) return;
      e.preventDefault();
      e.stopPropagation();
      handleWishlistItemClick(e, removeBtn);
    });
    document.addEventListener('keydown', function (e) {
      if (e.code === 'Escape') {
        var drawer = document.getElementById('WishlistDrawer');
        if (drawer && drawer.classList.contains('active')) closeDrawer();
      }
    });
  });

  document.addEventListener('wishlist:updated', function () {
    document.querySelectorAll('[data-wishlist-button]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      if (id) setButtonState(btn, isInWishlist(id));
    });
  });

  if (document.readyState === 'loading') return;
  updateHeaderCount();
})();
